import * as React from 'react';

import ArrowArcRight from './ArrowArcRight';

export const arrowArcRight = () => <ArrowArcRight />;

export default {
    title: 'Icon/Fill/ArrowArcRight',
    component: ArrowArcRight,
    parameters: {
        notes: "`import ArrowArcRight from 'box-ui-elements/es/icon/fill/ArrowArcRight';`",
    },
};
